export const ADD = 'ADD';
export const REMOVE = 'REMOVE';
export const CLEAR = 'CLEAR';

export const types = {
  ADD,
  REMOVE,
  CLEAR,
};
